// extracted by mini-css-extract-plugin
export var brand = "_b1-9";
export var compact = "_b1-6";
export var extraSmall = "_b1-7";
export var icon = "_b1-0";
export var large = "_b1-4";
export var light = "_b1-1";
export var medium = "_b1-5";
export var outline = "_b1-b";
export var primaryDark = "_b1-a";
export var primaryLight = "_b1-8";
export var primaryModern = "_b1-c";
export var success = "_b1-2";
export var successSolid = "_b1-3";